import React, {Component} from 'react';
import { Container,Carousel,Button,Row,Col, } from 'react-bootstrap';
import $ from 'jquery'
import Footer from './Footer'
import Fixed from './Fixed'
import './all.css'
import img1 from '../img/tl_banner.png'
import syrq from '../img/syrq.png'
import fwms from '../img/fwms.png'
import hjqxyl from '../img/hjqxyl.png'
import npnj from '../img/npnj.png'
import rfjk from '../img/rfjk.png'
import nbpl from '../img/nbpl.png'
import fyyf from '../img/fyyf.png'
import dhjfxf from '../img/dhjfxf.png'
import pfjs from '../img/pfjs.png'
import hxjfgz from '../img/hxjfgz.png'
import xyxh from '../img/xyxh.png'
import shwstt from '../img/shwstt.png'
import bhst from '../img/bhst.png'
import shjrst from '../img/shjrst.png'
import jhmyxt from '../img/jhmyxt.png'
import jkglfw from '../img/jkglfw.png'
import weektc from '../img/weektc.png'
import mouthtc from '../img/mouthtc.png'
import bntc from '../img/bntc.png'
import yeartc from '../img/yeartc.png'
import gmlc from '../img/gmlc.png'
import zysx from '../img/zysx.png'
import './all.css'


class RFConditioning extends Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    
    handleEnter = el=>{
        $('.'+el).css({'display':'block'})
    }
    handleOut = el=>{
        $('.'+el).css({'display':'none'})
    }
    render() {
        return (
            <div>
                <Row className='margin0'>
                    <img className="d-block w-100" src={img1} />
                </Row>
                <Row className="justify-content-md-center">
                    <Col xs="auto" lg={8}>
                        <img className="d-block w-100" src={syrq} style={{marginTop:'3%'}}/>
                    </Col>
                </Row>
                <Row className="justify-content-md-center">
                    <Col xs="auto" lg={8}>
                        <img className="d-block w-100" src={fwms} style={{marginTop:'3%'}}/>
                    </Col>
                </Row>
                <Row>
                    <Col className='textCenter'>
                        <h4 style={{marginTop:'3%'}}>润方调理服务</h4>
                        <div style={{margin:'2% 0'}}>Meridians assessment service</div>
                    </Col>
                </Row>
                <Row className="justify-content-md-center">
                    <Col lg={2}>
                        <div className='rftl_item' onMouseEnter={()=>this.handleEnter('hover1')} onMouseLeave={()=>this.handleOut('hover1')}>
                            <img src={hjqxyl} className="d-block w-100"/>
                            <div className='rftl_item_title textCenter'>解情绪压力</div>
                            <div className='rftl_item_msg'>舒缓压力，打开思路， 提升自我价值感，增进自信心，纾解忧郁情绪</div>
                            <div className='rftl_item_hover display_none hover1'>
                                <div className='rftl_item_hover_msg center'>舒缓压力，打开思路， 提升自我价值感，增进自信心，纾解忧郁情绪</div>
                                <div className='rftl_item_title_hover center'>解情绪压力</div>
                            </div>
                        </div>
                    </Col>
                    <Col lg={2}>
                        <div className='rftl_item' onMouseEnter={()=>this.handleEnter('hover2')} onMouseLeave={()=>this.handleOut('hover2')}>
                            <img src={npnj} className="d-block w-100"/>
                            <div className='rftl_item_title textCenter'>缓解尿频尿急</div>
                            <div className='rftl_item_msg'>有助于缓解良性前列腺增生产生的常见阻塞性症状和刺激性症状</div>
                            <div className='rftl_item_hover display_none hover2'>
                                <div className='rftl_item_hover_msg center'>有助于缓解良性前列腺增生产生的常见阻塞性症状和刺激性症状</div>
                                <div className='rftl_item_title_hover center'>缓解尿频尿急</div>
                            </div>
                        </div>
                    </Col>
                    <Col  lg={2}>
                        <div className='rftl_item' onMouseEnter={()=>this.handleEnter('hover3')} onMouseLeave={()=>this.handleOut('hover3')}>
                            <img src={npnj} className="d-block w-100"/>
                            <div className='rftl_item_title textCenter'>缓解术后疼痛</div>
                            <div className='rftl_item_msg'>缓解手术后疼痛，预防伤口感染， 促进伤口恢复，纾解术后情绪压力</div>
                            <div className='rftl_item_hover display_none hover3'>
                                <div className='rftl_item_hover_msg center'>缓解手术后疼痛，预防伤口感染， 促进伤口恢复，纾解术后情绪压力</div>
                                <div className='rftl_item_title_hover center'>缓解术后疼痛</div>
                            </div>
                        </div>
                    </Col>
                    <Col lg={2}>
                        <div className='rftl_item' onMouseEnter={()=>this.handleEnter('hover4')} onMouseLeave={()=>this.handleOut('hover4')}>
                            <img src={rfjk} className="d-block w-100"/>
                            <div className='rftl_item_title textCenter'>呵护乳房健康</div>
                            <div className='rftl_item_msg'>舒缓由于良性乳腺增生带来的胀痛刺痛等不适</div>
                            <div className='rftl_item_hover display_none hover4'>
                                <div className='rftl_item_hover_msg center'>舒缓由于良性乳腺增生带来的胀痛刺痛等不适</div>
                                <div className='rftl_item_title_hover center'>呵护乳房健康</div>
                            </div>
                        </div>
                    </Col>
                    <Col lg={2}>
                        <div className='rftl_item' onMouseEnter={()=>this.handleEnter('hover5')} onMouseLeave={()=>this.handleOut('hover5')}>
                            <img src={nbpl} className="d-block w-100"/>
                            <div className='rftl_item_title textCenter'>缓解脑部疲劳</div>
                            <div className='rftl_item_msg'>检查你的异常经脉异常数据，有效预警疾病发生并，在短时间内通知您以及家人</div>
                            <div className='rftl_item_hover display_none hover5'>
                                <div className='rftl_item_hover_msg center'>检查你的异常经脉异常数据，有效预警疾病发生并，在短时间内通知您以及家人</div>
                                <div className='rftl_item_title_hover center'>缓解脑部疲劳</div>
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row className="justify-content-md-center">
                    <Col lg={2}>
                        <div className='rftl_item' onMouseEnter={()=>this.handleEnter('hover6')} onMouseLeave={()=>this.handleOut('hover6')}>
                            <img src={fyyf} className="d-block w-100"/>
                            <div className='rftl_item_title textCenter'>新冠肺炎预防</div>
                            <div className='rftl_item_msg'>预防新冠肺炎，加强免疫系统，有助于保护细胞膜免受氧化代谢产物侵害</div>
                            <div className='rftl_item_hover display_none hover6'>
                                <div className='rftl_item_hover_msg center'>预防新冠肺炎，加强免疫系统，有助于保护细胞膜免受氧化代谢产物侵害</div>
                                <div className='rftl_item_title_hover center'>新冠肺炎预防</div>
                            </div>
                        </div>
                    </Col>
                    <Col lg={2}>
                        <div className='rftl_item' onMouseEnter={()=>this.handleEnter('hover7')} onMouseLeave={()=>this.handleOut('hover7')}>
                            <img src={dhjfxf} className="d-block w-100"/>
                            <div className='rftl_item_title textCenter'>淡化肌肤细纹</div>
                            <div className='rftl_item_msg'>激发肌肤的吸收和修复能力， 促进胶原蛋白产生，减少胶原蛋白流失</div>
                            <div className='rftl_item_hover display_none hover7'>
                                <div className='rftl_item_hover_msg center'>激发肌肤的吸收和修复能力， 促进胶原蛋白产生，减少胶原蛋白流失</div>
                                <div className='rftl_item_title_hover center'>淡化肌肤细纹</div>
                            </div>
                        </div>
                    </Col>
                    <Col  lg={2}>
                        <div className='rftl_item' onMouseEnter={()=>this.handleEnter('hover8')} onMouseLeave={()=>this.handleOut('hover8')}>
                            <img src={pfjs} className="d-block w-100"/>
                            <div className='rftl_item_title textCenter'>加强皮肤紧实</div>
                            <div className='rftl_item_msg'>促进肌肤主动再生，有助于加强面部皮肤紧实，有弹力， 提升面部立体感，改善松弛下坠感</div>
                            <div className='rftl_item_hover display_none hover8'>
                                <div className='rftl_item_hover_msg center'>促进肌肤主动再生，有助于加强面部皮肤紧实，有弹力， 提升面部立体感，改善松弛下坠感</div>
                                <div className='rftl_item_title_hover center'>加强皮肤紧实</div>
                            </div>
                        </div>
                    </Col>
                    <Col lg={2}>
                        <div className='rftl_item' onMouseEnter={()=>this.handleEnter('hover9')} onMouseLeave={()=>this.handleOut('hover9')}>
                            <img src={hxjfgz} className="d-block w-100"/>
                            <div className='rftl_item_title textCenter'>唤醒肌肤光泽</div>
                            <div className='rftl_item_msg'>促进毒素排出， 深层清洁皮肤，恢复皮肤的自然新陈代谢和调节能力</div>
                            <div className='rftl_item_hover display_none hover9'>
                                <div className='rftl_item_hover_msg center'>促进毒素排出， 深层清洁皮肤，恢复皮肤的自然新陈代谢和调节能力</div>
                                <div className='rftl_item_title_hover center'>唤醒肌肤光泽</div>
                            </div>
                        </div>
                    </Col>
                    <Col lg={2}>
                        <div className='rftl_item' onMouseEnter={()=>this.handleEnter('hover10')} onMouseLeave={()=>this.handleOut('hover10')}>
                            <img src={xyxh} className="d-block w-100"/>
                            <div className='rftl_item_title textCenter'>深化血液循环</div>
                            <div className='rftl_item_msg'>缓解手脚冰凉，腿部疼痛肿胀，疲劳和月经不调</div>
                            <div className='rftl_item_hover display_none hover10'>
                                <div className='rftl_item_hover_msg center'>缓解手脚冰凉，腿部疼痛肿胀，疲劳和月经不调</div>
                                <div className='rftl_item_title_hover center'>深化血液循环</div>
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row className="justify-content-md-center">
                    <Col lg={2}>
                        <div className='rftl_item' onMouseEnter={()=>this.handleEnter('hover11')} onMouseLeave={()=>this.handleOut('hover11')}>
                            <img src={shwstt} className="d-block w-100"/>
                            <div className='rftl_item_title textCenter'>舒缓外伤疼痛</div>
                            <div className='rftl_item_msg'>用于缓解突发意外外伤造成的疼痛止血，防止红肿/青紫於肿的产生</div>
                            <div className='rftl_item_hover display_none hover11'>
                                <div className='rftl_item_hover_msg center'>用于缓解突发意外外伤造成的疼痛止血，防止红肿/青紫於肿的产生</div>
                                <div className='rftl_item_title_hover center'>舒缓外伤疼痛</div>
                            </div>
                        </div>
                    </Col>
                    <Col lg={2}>
                        <div className='rftl_item' onMouseEnter={()=>this.handleEnter('hover12')} onMouseLeave={()=>this.handleOut('hover12')}>
                            <img src={bhst} className="d-block w-100"/>
                            <div className='rftl_item_title textCenter'>疤痕疏通</div>
                            <div className='rftl_item_msg'>疤痕会影响经脉能量的正常流动和信息的正常传输，经脉长期不通， 最终导致脏腑功能紊乱</div>
                            <div className='rftl_item_hover display_none hover12'>
                                <div className='rftl_item_hover_msg center'>疤痕会影响经脉能量的正常流动和信息的正常传输，经脉长期不通， 最终导致脏腑功能紊乱</div>
                                <div className='rftl_item_title_hover center'>疤痕疏通</div>
                            </div>
                        </div>
                    </Col>
                    <Col  lg={2}>
                        <div className='rftl_item' onMouseEnter={()=>this.handleEnter('hover13')} onMouseLeave={()=>this.handleOut('hover13')}>
                            <img src={shjrst} className="d-block w-100"/>
                            <div className='rftl_item_title textCenter'>舒缓肌肉酸痛</div>
                            <div className='rftl_item_msg'>激烈运动、运动强度过高、从事某些辛苦的劳动工作肌肉劳损过度导致肌肉痉挛，造成的肩颈肌肉僵硬</div>
                            <div className='rftl_item_hover display_none hover13'>
                                <div className='rftl_item_hover_msg center'>激烈运动、运动强度过高、从事某些辛苦的劳动工作肌肉劳损过度导致肌肉痉挛，造成的肩颈肌肉僵硬</div>
                                <div className='rftl_item_title_hover center'>舒缓肌肉酸痛</div>
                            </div>
                        </div>
                    </Col>
                    <Col lg={2}>
                        <div className='rftl_item' onMouseEnter={()=>this.handleEnter('hover14')} onMouseLeave={()=>this.handleOut('hover14')}>
                            <img src={jhmyxt} className="d-block w-100"/>
                            <div className='rftl_item_title textCenter'>强化免疫系统</div>
                            <div className='rftl_item_msg'>有助于保护细胞膜免受氧化代谢产物的侵害，预防细胞产生毒素和攻击性物质</div>
                            <div className='rftl_item_hover display_none hover14'>
                                <div className='rftl_item_hover_msg center'>有助于保护细胞膜免受氧化代谢产物的侵害，预防细胞产生毒素和攻击性物质</div>
                                <div className='rftl_item_title_hover center'>强化免疫系统</div>
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row className="justify-content-md-center">
                    <Col xs="auto" >
                        <img className="d-block w-100" src={jkglfw} style={{marginTop:'3%'}}/>
                    </Col>
                </Row>
                <Row>
                    <Col className='textCenter'>
                        <h4 style={{marginTop:'3%'}}>服务参考价格</h4>
                        <div style={{margin:'2% 0'}}>Health management services</div>
                    </Col>
                </Row>
                <Row className="justify-content-md-center">
                    <Col lg={2}>
                        <div className='rftl_item'>
                            <img src={weektc} className="d-block w-100"/>
                        </div>
                    </Col>
                    <Col lg={2}>
                        <div className='rftl_item'>
                            <img src={mouthtc} className="d-block w-100"/>
                        </div>
                    </Col>
                    <Col  lg={2}>
                        <div className='rftl_item'>
                            <img src={bntc} className="d-block w-100"/>
                        </div>
                    </Col>
                    <Col lg={2}>
                        <div className='rftl_item'>
                            <img src={yeartc} className="d-block w-100"/>
                        </div>
                    </Col>
                </Row>
                <Row className="justify-content-md-center">
                    <Col xs="auto" lg={8}>
                        <img className="d-block w-100" src={gmlc} style={{marginTop:'3%'}}/>
                    </Col>
                </Row>
                <Row>
                    <Col className='textCenter'>
                        <h4 style={{marginTop:'3%'}}>注意事项</h4>
                        <div style={{margin:'2% 0'}}>Matters needing attention</div>
                    </Col>
                </Row>
                <Row className="justify-content-md-center">
                    <Col xs="auto" lg={3}>
                        <img className="d-block w-100" src={zysx}/>
                    </Col>
                    <Col xs="auto" lg={5} style={{fontSize:12,lineHeight:'25px'}}>
                        <div>1、服务周期为周、月、半年者另需租赁押金: 聆枢测量笔￥3000；经疏干预棒￥5000。</div>
                        <div>2、用户使用周、月、半年服务套餐期满后，应及时归还，否则按实际归还时间计算扣除超出部分费用，押金扣完后服 务合同终结。</div>
                        <div>3、用户使用任何服务满一年后，如继续使用套餐，可在年套餐服务上打8折，并赠送1500积分。</div>
                        <div>4、当用户连续使用年套餐服务满三年，第四年继续使用时，设备可享受一次以旧换新活动。</div>
                        <div>5、当用户丢失服务套餐中的设备后如需继续使用服务须补交检测笔费用2100元，干预棒费用5600元，系统将禁用丢 失的设备。</div>
                        <div>6、用户如果中途想升级套餐时，费用为升级套餐的费用-旧套餐累计花费的费用=需补交的钱数，服务有效期为1年- 旧套餐累计已用的时间=可用的有效期 </div>
                        <div>7、所有服务项目有效期均为一年</div>
                    </Col>
                </Row>
                <Footer/>
                <Fixed/>
            </div>
        )
    }
}

export default RFConditioning;

